import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AuthState, withAuth } from 'context/auth';
import { withAlerts, AlertsState } from 'context/alerts';
import {
  Button,
  LoadingIndicator,
  LoginButton,
  Jumbotron,
} from 'components';
import { slideUp } from 'styles/animations';
import { media } from 'styles/media';
import { useNavigate } from 'react-router-dom';

const StyledWelcome = styled.h2`
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 10px;
  font-size: ${p => p.theme.fontSize['2xl']};
  text-align: center;
`;
const StyledTitle = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  font-size: ${p => p.theme.fontSize.hero};
  line-height: 1;
  text-align: center;
`;
const StyledDescription = styled.p`
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: ${p => p.theme.fontSize.xl};
  max-width: 440px;
`;
const StyledSandboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${p => p.theme.colors.deepGreyTransparent};
  padding: 30px 50px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  max-width: 700px;
  width: 100%;
  ${slideUp}

  ${media.md} {
    padding: 24px 16px;
  }

  > p {
    margin-top: 0;
    font-size: ${p => p.theme.fontSize.lg};
    text-align: center;
  }

  ${Button} {
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

interface Props {
  auth: AuthState;
  alerts: AlertsState;
}

const WelcomePage = (props: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Wait until user has logged in and check sandboxes after it.
    // If user has only one sandbox, redirect straight to it
    if (props.auth.loggedIn) {
      if (
        props.auth.sandboxesAvailable.length > 1 ||
        props.auth.sandboxesAvailable.length === 0
      )
        return;

      navigate(`/${props.auth.sandboxesAvailable[0].id}`);
    }
  });

  const renderLowerHalf = () => {
    const auth = props.auth;
    if (auth.loggedIn === undefined && !props.alerts.message) {
      return <LoadingIndicator />;
    }

    if (auth.loggedIn === false) {
      return (
        <>
          <StyledDescription>
            Login with your {process.env.REACT_APP_SANDBOX_DOMAIN} account.
          </StyledDescription>
          <LoginButton />
        </>
      );
    }

    if (auth.loggedIn === true) {
      return (
        <>
          <StyledSandboxesContainer id="dark-container">
            <StyledDescription>
              You have been logged in succesfully!
            </StyledDescription>
            <StyledDescription>Please select a sandbox:</StyledDescription>
            {auth.sandboxesAvailable.map((sandbox: any) => (
              <Button
                key={sandbox.id}
                type="button"
                onClick={() => {
                  navigate(`/${sandbox.id}`);
                }}
              >
                {sandbox.name}
              </Button>
            ))}
          </StyledSandboxesContainer>
        </>
      );
    }
  };

  const renderUpperHalf = () => {
    return (
      <>
        <StyledWelcome id="welcome-text">Welcome to</StyledWelcome>
        <StyledTitle id="welcome-title">
          {process.env.REACT_APP_SANDBOX_NAME}
        </StyledTitle>
      </>
    );
  };

  return (
    <>
      <Jumbotron upperHalf={renderUpperHalf()} lowerHalf={renderLowerHalf()} />
    </>
  );
};
export default withAuth(withAlerts(WelcomePage));
